import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Trust from '@/components/Trust';
import About from '@/components/About';
import EntityOverview from '@/components/EntityOverview';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-orange-100">
      <Header />
      <main>
        <Hero />
        <Trust />
        <About />
        <EntityOverview />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}